"use client";

import React from "react";
import { Shield, Clock, Award } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Fully Insured",
  description: "Rest easy knowing your luxury property is protected by comprehensive insurance coverage and professional protocols.",
  icon: Shield
}, {
  title: "6-Hour Quote",
  description: "Time is your most valuable asset. We guarantee a detailed, affordable quote within 6 hours of your request.",
  icon: Clock
}, {
  title: "5 Years Experience",
  description: "Half a decade of perfecting the art of window cleaning across Toronto's most prestigious residential estates.",
  icon: Award
}];
export default function The6StarStandard() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224397" id="the-6spc-standard" className="py-24 bg-background text-foreground overflow-hidden relative">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-from)_0%,_transparent_70%)] from-accent/20 to-transparent pointer-events-none" />
      
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="text-center max-w-2xl mx-auto mb-16">
            <h2 className="font-default text-3xl md:text-4xl font-bold text-primary mb-4 tracking-tight uppercase">
              The 6SPC Standard
            </h2>
            <p className="font-sans text-muted-foreground text-lg font-light">
              Luxury level window cleaning guaranteed. We combine technical precision with elite service for the GTA's finest homes.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {features.map((feature, i) => {
            const Icon = feature.icon;
            return <div data-index={i} key={i}>
                  <Card className="h-full bg-card border-t border-x-0 border-b-0 border-t-muted-foreground/30 transition-all duration-500 hover:-translate-y-2 hover:shadow-xl hover:bg-accent/50 group rounded-md">
                    <CardHeader className="pb-4">
                      <div className="w-14 h-14 rounded-md bg-primary/5 flex items-center justify-center mb-4 text-muted-foreground group-hover:text-primary group-hover:scale-110 transition-all duration-300">
                        <Icon className="w-7 h-7" strokeWidth={1} />
                      </div>
                      <CardTitle className="font-default text-xl text-primary font-semibold tracking-wide">
                        {feature.title}
                      </CardTitle>
                    </CardHeader>
                    <CardContent>
                      <p className="font-sans text-muted-foreground leading-relaxed font-light">
                        {feature.description}
                      </p>
                    </CardContent>
                  </Card>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}